module.exports = __webpack_public_path__ + "img/enter-otp-animate.f58fffe2.svg";